import React, { useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Paper, TablePagination, Skeleton } from "@mui/material";
export default function DataTable({ columns, rows, loading = false, getRowStyle }) {
    const [orderBy, setOrderBy] = useState("");
    const [order, setOrder] = useState("asc");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const handleSort = (column) => {
        const isAsc = orderBy === column && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(column);
    };
    const sortedRows = [...rows].sort((a, b) => {
        if (!orderBy) return 0;
        const aValue = a[orderBy];
        const bValue = b[orderBy];
        if (aValue < bValue) return order === "asc" ? -1 : 1;
        if (aValue > bValue) return order === "asc" ? 1 : -1;
        return 0;
    });
    return (
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ width: "100%", overflowX: "auto", WebkitOverflowScrolling: "touch", }}>
                <Table sx={{ minWidth: 800 }}>
                    <TableHead>
                        <TableRow>
                            {columns.map((col, index) => (
                                <TableCell key={index}>
                                    <TableSortLabel active={orderBy === index} direction={order} onClick={() => handleSort(index)}>{col}</TableSortLabel>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading
                            ? [...Array(5)].map((_, i) => (
                                <TableRow key={i}>
                                    {columns.map((_, j) => (<TableCell key={j}><Skeleton /></TableCell>))}</TableRow>
                            ))
                            : sortedRows
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, i) => (
                                    // <TableRow key={i}>
                                    //     {row.map((cell, index) => (
                                    //         <TableCell key={index}>{cell}</TableCell>
                                    //     ))}
                                    // </TableRow>
                                    <TableRow
                                        key={i}
                                        sx={getRowStyle ? getRowStyle(row) : {}}
                                    >
                                        {row.map((cell, index) => (
                                            <TableCell key={index}>
                                                {cell}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                onRowsPerPageChange={(e) => {
                    setRowsPerPage(parseInt(e.target.value, 10));
                    setPage(0);
                }} />
        </Paper>
    );
}


// import React, { useMemo, useState } from "react";
// import "./DataTable.css";

// export default function DataTable({ columns, rows, loading = false, getRowStyle, }) {
//     const [page, setPage] = useState(0);
//     const [rowsPerPage, setRowsPerPage] = useState(10);
//     const paginatedRows = useMemo(() => {
//         return rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
//     }, [rows, page, rowsPerPage]);
//     return (
//         <div className="datatable-wrapper">
//             <div className="datatable-scroll">
//                 <table className="datatable">
//                     <thead>
//                         <tr>
//                             {columns.map((col, index) => (
//                                 <th key={index}>{col}</th>
//                             ))}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {loading ? (
//                             [...Array(5)].map((_, i) => (
//                                 <tr key={i}>
//                                     {columns.map((_, j) => (
//                                         <td key={j}>Loading...</td>
//                                     ))}
//                                 </tr>
//                             ))
//                         ) : paginatedRows.length > 0 ? (
//                             paginatedRows.map((row, index) => (
//                                 <tr key={index} style={getRowStyle ? getRowStyle(row) : {}}>
//                                     {row.map((cell, i) => (
//                                         <td key={i}>{cell}</td>
//                                     ))}
//                                 </tr>
//                             ))
//                         ) : (
//                             <tr>
//                                 <td colSpan={columns.length} style={{ textAlign: "center" }}>No Records Found</td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>
//             <div className="datatable-footer">
//                 <div>Rows per page
//                     <select value={rowsPerPage} onChange={(e) => { setRowsPerPage(Number(e.target.value)); setPage(0); }}>
//                         <option value={5}>5</option>
//                         <option value={10}>10</option>
//                         <option value={25}>25</option>
//                         <option value={50}>50</option>
//                     </select>
//                 </div>
//                 <div>
//                     {page * rowsPerPage + 1} -
//                     {Math.min((page + 1) * rowsPerPage, rows.length)}
//                     {" "}of {rows.length}
//                 </div>
//                 <div>
//                     <button disabled={page === 0} onClick={() => setPage(page - 1)} >◀</button>
//                     <button disabled={(page + 1) * rowsPerPage >= rows.length} onClick={() => setPage(page + 1)}>▶</button>
//                 </div>
//             </div>
//         </div>
//     );
// }